import { TableCell } from '@/components/Table'
import cx from 'classnames'
import styles from './QuantityCell.module.css'

interface QuantityCellProps {
  children: number
}

export function QuantityCell({ children }: QuantityCellProps) {
  return (
    <TableCell>
      <div
        className={cx(
          styles.quantity,
          children > 0 ? styles.quantityPositive : styles.quantityNegative,
        )}
      >
        {formatQuantity(children)}
      </div>
    </TableCell>
  )
}

function formatQuantity(q: number): string {
  if (q > 0) {
    return '+' + q
  }

  return q.toString()
}
